import React from "react";
import styled from "styled-components";
import MuzeLogo from "../../../images/logo.svg";

const StyledLogo = styled.img`
    max-width: 330px;
    width: 95%;
    margin: 25px auto 15px;
    display: block;
`;

const Logo = () => <StyledLogo src={MuzeLogo} alt="Muze" />;

export default Logo;
